import {Banner, BannerContent, Button, FlexItem, FlexLayout, Spinner, Text} from "@salt-ds/core";
import {useNavigate} from "react-router";
import Constants from "./Constants"
import "./PasswordExpiringSoonModel.css"
import React, {useEffect, useRef} from "react";

export default function PasswordExpiringSoonModal(props) {

  const navigate = useNavigate();
  const mainRef = useRef(null);

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, []);

  const handleChangeNowClick = () => {
    props.closeAndClearModal();
    navigate(Constants.changeExpiringPassword, {
      state: {
        from: Constants.fromPasswordExpiringModal,
        passwordExpiryData: props.passwordExpiryFormData || {}
      }
    });
  }

  const handleRemindMeLaterClick = () => {
    props.closeAndClearModal();
    if (props.onRemindMeLater) {
      props.onRemindMeLater();
    }
    props.setShowRedirect(true);
    if (!props.useTargetRedirect) {
      window.location.href = `${window.location.origin}/card/home`;
    }
  }

  return (
    <FlexItem
      ref={mainRef}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-heading"
      tabIndex="-1"
    >
    <Banner className={"modal-heading"}>
      <BannerContent>
        <Text>{Constants.expiringSoonModalHeading}</Text>
      </BannerContent>
    </Banner>
    <Text
      className={"modal-text"}>{Constants.expiringSoonModalText(props.passwordExpiryFormData?.daysUntilPasswordExpires, props.passwordExpiryFormData?.daysUntilNextReminder)}</Text>
    <FlexLayout className={"modal-flex"}>
      <FlexItem>
        <Button onClick={handleRemindMeLaterClick} type="submit" sentiment="accented" appearance="bordered">
          {Constants.expiringSoonModalActionRemindLater}
        </Button>
      </FlexItem>
      <FlexItem>
        <Button onClick={handleChangeNowClick} type="submit" sentiment={"accented"}>
          {Constants.expiringSoonModalActionChangeNow}
        </Button>
      </FlexItem>
    </FlexLayout>

  </FlexItem>);
}
